import { Schema, arrayOf } from 'normalizr'

export const address = new Schema('addresses')
export const arrayOfAddresses = arrayOf(address)
